// Contact Electric - featured sponsor across the app
export const SPONSOR = {
  name: 'Contact Electric',
  city: 'Lake Worth, FL',
  phone: '561-441-2397',
  phoneHref: 'tel:+15614412397',
  tagline: 'Your trusted local electrical pro',
  trades: ['Electrical'], // when solution.trade matches, boost placement
};

// Case-insensitive/substring match against solution.trade
export function sponsorMatchesTrade(trade) {
  if (!trade || typeof trade !== 'string') return false;
  const t = trade.toLowerCase();
  return SPONSOR.trades.some((x) => t.includes(x.toLowerCase()) || x.toLowerCase().includes(t));
}
